import React from 'react';
import { ForgeListItem } from '@tylertech/forge-react';
import { hasEmbeddedExecutionMethod } from '../helpers/processDiscoveryHelper';

interface ProcessDiscoveryLinkItemProps {
  entry: any;
  index: number;
  onLinkClick: (url: string) => void;
}

const ProcessDiscoveryLinkItem = ({ entry, onLinkClick, index }: ProcessDiscoveryLinkItemProps) => {
  const isEmbeddedExecution = hasEmbeddedExecutionMethod(entry);
  const aTagAttributes = isEmbeddedExecution
    ? { href: '#', onClick: () => onLinkClick(entry.url) }
    : { target: '_blank', rel: 'noopener noreferrer', href: entry.url };

  return (
    <ForgeListItem key={index}>
      <a {...aTagAttributes}>{entry.name}</a>
    </ForgeListItem>
  );
};

export default ProcessDiscoveryLinkItem;
